<script setup lang="ts">
  import { type UseSwipeDirection } from "@vueuse/core";
  import { Talk } from "~/entities/Talk";

  interface Props {
    isOpen: boolean;
    talkIndex: number;
    imageTalks: Talk[];
  }
  const props = defineProps<Props>();

  interface Emits {
    (event: "update:isOpen", isOpen: boolean): void;
  }
  const emit = defineEmits<Emits>();
  const computedIsOpen = computed<boolean>({
    get: () => props.isOpen,
    set: value => {
      emit("update:isOpen", value);
    },
  });

  const clickClose = () => {
    computedIsOpen.value = false;
    marginClicked.value = false;
  };
  // 余白がクリックされたら閉じる
  const marginClicked = ref(false);
  watchEffect(() => {
    if (marginClicked.value) {
      clickClose();
    }
  });

  const currentTalkIndex = ref(props.talkIndex);
  const canPrev = computed(() => currentTalkIndex.value > 0);
  const goPrev = () => {
    if (canPrev.value) {
      currentTalkIndex.value--;
    }
  };
  const canNext = computed(() => currentTalkIndex.value < props.imageTalks.length - 1);
  const goNext = () => {
    if (canNext.value) {
      currentTalkIndex.value++;
    }
  };

  const isSp = isSpDisplayRef();

  const onFlick = (direction: UseSwipeDirection) => {
    if (direction === "left") {
      goNext();
    } else if (direction === "right") {
      goPrev();
    }
  };
</script>

<template>
  <v-dialog v-model="computedIsOpen" fullscreen scrim="transparent">
    <div v-if="isOpen" class="d-flex flex-column justify-center dialog-body">
      <!-- SP版 スワイプで移動 -->
      <AtomsFlickGesture v-if="isSp" @on-flick:direction="onFlick">
        <OrganismsTalkImageCarousel
          v-model:margin-clicked="marginClicked"
          :talk-index="currentTalkIndex"
          :image-talks="imageTalks"
        >
        </OrganismsTalkImageCarousel>
      </AtomsFlickGesture>

      <!-- PC版: 矢印で移動 -->
      <v-row v-else>
        <v-col cols="1" class="my-auto text-right">
          <div v-if="canPrev" style="cursor: pointer" @click="goPrev">
            <img src="@/assets/images/icon/arrow-circle-left.svg" alt="arrow-left" />
          </div>
        </v-col>
        <v-col>
          <OrganismsTalkImageCarousel
            v-model:margin-clicked="marginClicked"
            :talk-index="currentTalkIndex"
            :image-talks="imageTalks"
          >
          </OrganismsTalkImageCarousel>
        </v-col>
        <v-col cols="1" class="my-auto text-left">
          <div v-if="canNext" style="cursor: pointer" @click="goNext">
            <img src="@/assets/images/icon/arrow-circle-right.svg" alt="arrow-right" />
          </div>
        </v-col>
      </v-row>

      <div class="close-button d-flex justify-center align-center">
        <v-icon size="24px" color="white" icon="$mdiClose" @click="clickClose"></v-icon>
      </div>
    </div>
  </v-dialog>
</template>

<style lang="scss" scoped>
  .dialog-body {
    color: rgb(var(--v-theme-text));
    background-color: rgba(0, 0, 0, 0.8);
    width: 100%;
    height: 100%;
  }
  .close-button {
    width: 40px;
    min-width: 40px;
    height: 40px;
    min-height: 40px;
    position: absolute;
    right: 20px;
    top: 40px;
    transform: translate(0%, -50%);
    -webkit-transform: translate(0%, -50%);
    -ms-transform: translate(0%, -50%);
    background: #646464bf;
    border-radius: 50%;
  }
</style>
